<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-list
        class="fill-height"
        column
      >
        <v-list-item id="list-avatar">
          <v-list-item-avatar
            color="white"
          >
            <v-img
              :src="logo"
              height="34"
              contain
            />
          </v-list-item-avatar>
          <v-list-item-title class="title">
            {{ username }}
          </v-list-item-title>
        </v-list-item>
        <v-divider/>
        <v-list-item
          v-for="(link, i) in links" 
          v-show="hasRole(link.role)"
          :id="link.name"
          :key="i"
          :to="link.to"
          :active-class="color"
          class="v-list-item"
        >
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title
            v-text="link.text"
          />
        </v-list-item>
        <v-divider />
        <v-list-item
          id="logout"
          :active-class="color"
          @click="logout"
          class="v-list-item"
        >
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-title
            v-text="`Sair`"
          />
        </v-list-item>
      </v-list>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
const ADMIN_ROLE = 'ADMIN'
const ORGANIZATION_ROLE = 'ORGANIZATION'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    logo: 'favicon.ico',
    links: [
      {
        to: '/',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
        role: [ORGANIZATION_ROLE, ADMIN_ROLE]
      },
      {
        to: '/organization',
        icon: 'mdi-city',
        text: 'Organizações',
        role: [ORGANIZATION_ROLE, ADMIN_ROLE]
      },
      {
        to: '/product',
        icon: 'mdi-apps',
        text: 'Produtos',
        role: [ADMIN_ROLE]
      },
      {
        to: '/user',
        icon: 'mdi-account',
        text: 'Usuários',
        role: [ORGANIZATION_ROLE, ADMIN_ROLE]
      },
      {
        to: '/role',
        name: 'role',
        icon: 'mdi-grain',
        text: 'Perfis',
        role: [ADMIN_ROLE]
      },
      {
        to: '/permission',
        icon: 'mdi-menu',
        text: 'Permissões',
        role: [ADMIN_ROLE]
      }
    ]
  }),
  computed: {
    ...mapState('app', ['image', 'color', 'user']),
    ...mapGetters('app', ['hasRole']),
    username() {
      if (this.user) {
        return (this.user.user_name || '')
      }
      return ''
    },
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    logout() {
      this.$router.push({
        path: '/logout',
        query: { 
          callback: window.location.href,
          client_id: this.$store.state.credentials.client_id,
          client_secret: this.$store.state.credentials.client_secret
        }
      })
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    #list-avatar {
        margin-top: 0px
    }
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }
  }
</style>
